export default "__VITE_ASSET__DwIoEEw7__"